import React from 'react';
import { LinkContainer } from 'react-router-bootstrap';
import Button from 'react-bootstrap/Button';

const LogoutLinkContainer = ({ variant, logout }) => {
  const handleClick = async (e) => {
    e.preventDefault();
    logout();
  };

  return (
    <LinkContainer to="/">
      <Button variant={variant} onClick={handleClick}>
        Log Out
      </Button>
    </LinkContainer>
  );
};

export default LogoutLinkContainer;
